export const ACTIVE = 'ACTIVE', VALIDATED = 'VALIDATED', REGISTERED = 'REGISTERED', PAYMENT_PENDING = 'PAYMENT_PENDING',
    PAYMENT_WAITING = 'PAYMENT_WAITING', PAYMENT_FAILURE = 'PAYMENT_FAILURE', EXPIRED = 'EXPIRED', DELETED = 'DELETED',
    TYPE_FREE = 'FREE', TYPE_PAY = 'PAY';